// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavService } from '@services/nav.service';
import { LoginService } from '../services/login.service';

@Component({
    selector: 'app-reset-token-form',
    templateUrl: './reset-token-form.component.html',
    styleUrls: ['./reset-token-form.component.scss'],
})
export class ResetTokenFormComponent implements OnInit {
    error: string = null;
    resetTokenForm: FormGroup = new FormGroup({
        token: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(/^\d{6}$/)]),
    });
    username: string = null;
    public enterToken = false;

    constructor(
        private readonly loginService: LoginService,
        private readonly router: Router,
        private readonly navService: NavService
    ) {
        const email = this.loginService.getEmail();
        if (!email) {
            this.router.navigate(['/login', 'reset-password']);
        }

        const name = email.substring(0, email.indexOf('@'));
        const domain = email.split('@')[1];
        const subStr = email.substring(1, name.length - 1);
        const hiddenUsername = new Array(subStr.length + 1).join('*');
        this.username = `${name.slice(0, 1)}${hiddenUsername}${name.slice(-1)}@${domain}`;
    }

    ngOnInit() {
        this.navService.setTitle('Create New Password');
    }

    resetTokenSubmit(): void {
        if (this.resetTokenForm.valid) {
            this.loginService.setResetToken(this.resetTokenForm.value.token);
            this.router.navigate(['/login', 'new-password']);
        }
    }

    fieldError(form: FormGroup, name: string): string {
        const ctl = form.get(name);

        if (ctl.hasError('required')) {
            return 'You must enter a value';
        } else if (ctl.hasError('token')) {
            return 'Invalid token';
        } else if (ctl.hasError('pattern')) {
            return 'Please ensure the token you entered has no spaces, and consists of only numbers';
        } else {
            return null;
        }
    }
}
